module.exports = __webpack_public_path__ + "static/media/horoscope-icon-0.4685a4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-0.png
// module id = 1524
// module chunks = 0